export const ADD_TO_BOARD = 'ADD_TO_BOARD'
export const SET_ROOM = 'SET_ROOM'
export const SET_HAND = 'SET_HAND'
export const REMOVE_FROM_HAND = 'REMOVE_FROM_HAND'
export const EMPTY_HAND = 'EMPTY_HAND'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const SET_PLAYER = 'SET_PLAYER'
export const ADD_TO_HAND = 'ADD_TO_HAND'

interface BoardAction {
    type: typeof ADD_TO_BOARD
    newBoard: Object[]
}
interface SetRoom {
    type: typeof SET_ROOM
    roomCode: typeof Number | any
}

interface SetHand {
    type: typeof SET_HAND
    hand: typeof Array | any
}
interface RemoveFromHand {
    type: typeof REMOVE_FROM_HAND
    idx: number
}
export interface Props {
    children: JSX.Element[] | JSX.Element;
}

interface EmptyHand {
    type: typeof EMPTY_HAND
}

interface UpdateField {
    type: typeof UPDATE_FIELD
    col: number,
    row: number,
    char: string,
    player: number

}

interface SetPlayer {
    type: typeof SET_PLAYER,
    id: number
}
interface AddToHand {
    type: typeof ADD_TO_HAND,
    item: string
}
export type BoardTypes = BoardAction | UpdateField
export type RoomTypes = SetRoom
export type HandTypes = SetHand | RemoveFromHand | EmptyHand | AddToHand
export type PlayerTypes = SetPlayer


export const toastrOptions = { showCloseButton: false };